import useCombinedRefs from '@/hooks/useCombinedRefs'
import React, { forwardRef } from 'react'
import { useInView } from 'react-intersection-observer'

function VirtualScrollChild (props, forwardRef) {
  const [ref, inView] = useInView({ rootMargin: props.rootMargin })
  const combinedRefs = useCombinedRefs(ref, forwardRef)

  const style = {
    minHeight: `${props.height}px`
  }

  return (
    <div className="virtual-scroll-child" style={style} ref={combinedRefs} data-anchor={props.anchor}>
      {inView ? props.children : null}
    </div>
  )
}

export default forwardRef(VirtualScrollChild)
